module.exports = __webpack_public_path__ + "static/img_0905-b3321d2b5e83a492a3f0e2ea2d0cc81c.webp";